<template>
    <div class="mds-alert" :class="alertClasses" role="alert">
        <div class="mds-alert__cell-icon">
            <mds-icon class="mds-alert__icon" :name="iconName"></mds-icon>
        </div>
        <div class="mds-alert__cell-body">
            <aside class="mds-alert__content">
                <strong class="mds-alert__title" v-if="hasTitle">{{ title }}</strong>
                <p class="mds-alert__message">
                    <slot v-bind:text="text">{{ text }}</slot>
                </p>
            </aside>
        </div>
        <mds-button
            v-if="dismissible"
            :text="dismissibleIconAriaLabel"
            type="button"
            variation="icon-only"
            size="small"
            class="mds-alert__dismiss-button"
            icon="remove--s"
        ></mds-button>
    </div>
</template>

<script>
import MdsIcon from "./Icon";
import MdsButton from "./Button";
export default {
    name: "mds-alert",
    props: {
        dismissible: {
            type: Boolean,
            default: true
        },
        dismissibleIconAriaLabel: {
            type: String,
            default: ""
        },
        size: {
            type: String,
            default: "medium",
            validator: function(value) {
                return ["small", "medium"].indexOf(value) > -1;
            }
        },
        text: String,
        tinted: {
            type: Boolean,
            default: false
        },
        title: String,
        variation: {
            type: String,
            default: "informational",
            validator: function(value) {
                return ["error", "warning", "success", "informational"].indexOf(value) > -1;
            }
        }
    },
    components: {
        MdsIcon,
        MdsButton
    },
    computed: {
        alertClasses() {
            return {
                [`mds-alert--${this.variation}`]: !!this.variation,
                "mds-alert--dismissible": this.dismissible,
                "mds-alert--tinted": this.tinted
            };
        },
        iconName() {
            const alertTypeIconMapping = {
                error: "alert",
                warning: "alert",
                success: "check",
                informational: "info-circle"
            };
            return alertTypeIconMapping[this.variation];
        },
        hasTitle() {
            return this.title !== undefined && this.title !== "";
        }
    }
};
</script>
